
//  Stimulus controller imports and register
//      [index.js]

import { Application } from "@hotwired/stimulus";
import ImageEditController from "./layouts/image_edit_controller.ts";
import PreviewController from "./layouts/preview_controller.ts";


window.Stimulus ||= Application.start();
window.Stimulus.register("image-edit", ImageEditController);
window.Stimulus.register("preview", PreviewController);



